export default "__VITE_ASSET__C$0UbGqz__"